export default {
    _setXmppCreds(state, xmppParams) {
        state.xmppCreds = { ...xmppParams };
    },
};
